// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"usergroup-add"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M19 8C19 10.2091 17.2091 12 15 12C12.7909 12 11 10.2091 11 8C11 5.79086 12.7909 4 15 4C17.2091 4 19 5.79086 19 8Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M9 4C6.79086 4 5 5.79086 5 8C5 10.2091 6.79086 12 9 12C5.68629 12 3 14.6863 3 18V21M14 15H12C9.79086 15 8 16.7909 8 19V21H14M19 8C19 10.2091 17.2091 12 15 12C12.7909 12 11 10.2091 11 8C11 5.79086 12.7909 4 15 4C17.2091 4 19 5.79086 19 8Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M20 15V18M20 18V21M20 18H17M20 18H23","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const UsergroupAddIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'usergroup-add',
    ref,
    icon: element,
  },
));

UsergroupAddIcon.displayName = 'UsergroupAddIcon';

export default UsergroupAddIcon;
